import * as React from "react";
import { useTranslation } from "react-i18next";
import { Icon, ClipboardButton } from "components/common";
import ErrorPage from "components/errors/ErrorPage";
import withLocation from "routing/withLocation";
const createErrorMessageString = (errorDetails, pageDetails, errorMessage) => [errorDetails, pageDetails, errorMessage].filter((part) => !!part).join("\n");
const UnauthorizedErrorPage = ({
  error = void 0,
  errorDetails = void 0,
  title = void 0,
  description = void 0,
  displayPageLayout = true,
  location: { pathname }
}) => {
  var _a;
  const { t } = useTranslation("pages");
  const errorMessage = error ? (_a = error.message) != null ? _a : JSON.stringify(error) : void 0;
  const pageDetails = error ? t("unauthorized.page_details", { pathname }) : t("unauthorized.page_details_no_request", { pathname });
  const defaultDescription = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("unauthorized.description_intro")), /* @__PURE__ */ React.createElement("p", null, t("unauthorized.description_hint")));
  const errorMessageString = createErrorMessageString(errorDetails, pageDetails, errorMessage);
  return /* @__PURE__ */ React.createElement(
    ErrorPage,
    {
      title: title != null ? title : t("unauthorized.title"),
      description: description != null ? description : defaultDescription,
      displayPageLayout
    },
    /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement("pre", { className: "content" }, /* @__PURE__ */ React.createElement("div", { className: "pull-right" }, /* @__PURE__ */ React.createElement(
      ClipboardButton,
      {
        title: /* @__PURE__ */ React.createElement(Icon, { name: "content_copy" }),
        bsSize: "sm",
        text: errorMessageString,
        buttonTitle: t("errors.copy_error_details")
      }
    )), errorDetails && /* @__PURE__ */ React.createElement("p", null, errorDetails), /* @__PURE__ */ React.createElement("p", null, pageDetails), errorMessage && /* @__PURE__ */ React.createElement("p", null, errorMessage))))
  );
};
export default withLocation(UnauthorizedErrorPage);
